import React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';

import IconDotsTyping from './IconDotsTyping';

const styles = () =>
  createStyles({
    wrapperLoading: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  });

interface IconLoadingProps extends WithStyles<typeof styles> {}

const IconLoading: React.FC<IconLoadingProps> = ({ classes }) => (
  <div className={classes.wrapperLoading}>
    <IconDotsTyping />
  </div>
);

export default withStyles(styles, { name: 'IconLoading' })(IconLoading);
